export type MenuItemType = {
    key: string;
    label: string;
    isTitle?: boolean;
    icon?: string;
    url?: string;
    target?: string;
    badge?: {
        variant: string;
        text: string;
    }; 
    parentKey?: string;
    children?: MenuItemType[];
};
const REACT_APP_OLD_ADMIN_URL = process.env.REACT_APP_OLD_ADMIN_URL;

const getOldAdminUrl = (urlPath: string) => {
    return `${REACT_APP_OLD_ADMIN_URL}/${urlPath}`;
};

const MENU_ITEMS: MenuItemType[] = [
    { key: 'navigation', label: 'ÁREA ADMINISTRATIVA', isTitle: true },
    {
        key: 'definicoes',
        label: 'Definições',
        isTitle: false,
        icon: 'mdi mdi-book-edit-outline',
        children: [
            { key: 'gestores', label: 'Gestores', url: 'gestores', parentKey: 'definicoes' },
            { key: 'contas', label: 'Contas Bancárias', url: 'contasbancarias', parentKey: 'definicoes' },
            { key: 'fornecedores', label: 'Fornecedores', url: 'fornecedores', parentKey: 'definicoes' },
            { key: 'contratos', label: 'Contratos', url: getOldAdminUrl('contratos'), parentKey: 'definicoes' },
            { key: 'exercicios', label: 'Exercícios', url: getOldAdminUrl('exercicios'), parentKey: 'definicoes' },
            { key: 'programas', label: 'Programas', url: getOldAdminUrl('programas'), parentKey: 'definicoes' },
            { key: 'usuarios', label: 'Usuários', url: '', parentKey: 'definicoes' },
            { key: 'tabelas', label: 'Tabelas', url: '', parentKey: 'definicoes' }
        ],
    },
    {
        key: 'movimentos',
        label: 'Movimentos',
        isTitle: false,
        icon: 'uil-layer-group',
        children: [
            { key: 'convenios', label: 'Convênios', url: 'convenios', parentKey: 'movimentos' },
            { key: 'lancamentos_new', label: 'Lançamentos', url: 'lancamentos', parentKey: 'movimentos' }
        ],
    },
    {
        key: 'admin-site',
        label: 'Admin. Site',
        isTitle: false,
        icon: 'uil-globe',
        children: [
            { key: 'noticias', label: 'Notícias', url: getOldAdminUrl('noticias'), parentKey: 'admin-site' },
        ],
    }
];

export { MENU_ITEMS };
